const DeleteTrashLine = ({ className = '', ...props }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M8.66992 3.39648H11.1699V4.39648H10.1699V10.8965C10.1699 11.0291 10.1172 11.1563 10.0235 11.25C9.92971 11.3438 9.80253 11.3965 9.66992 11.3965H2.66992C2.53731 11.3965 2.41014 11.3438 2.31637 11.25C2.2226 11.1563 2.16992 11.0291 2.16992 10.8965V4.39648H1.16992V3.39648H3.66992V1.89648C3.66992 1.76388 3.7226 1.6367 3.81637 1.54293C3.91014 1.44916 4.03731 1.39648 4.16992 1.39648H8.16992C8.30253 1.39648 8.42971 1.44916 8.52348 1.54293C8.61724 1.6367 8.66992 1.76388 8.66992 1.89648V3.39648ZM9.16992 4.39648H3.16992V10.3965H9.16992V4.39648ZM4.66992 5.89648H5.66992V8.89648H4.66992V5.89648ZM6.66992 5.89648H7.66992V8.89648H6.66992V5.89648ZM4.66992 2.39648V3.39648H7.66992V2.39648H4.66992Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default DeleteTrashLine;
